export const BREAKPOINTS = {
   small:  {
      px: 576,
      em: 36,
   },
   medium: {
      px: 768,
      em: 48
   },
   large: {
      px: 992,
      em: 62,
   },
   xlarge: {
      px: 1440,
      em: 90,
   },
};
